import * as type from "../../types/API/eInvoiceCredentialType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const createEInvoiceCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.CREATE_EINVOICE_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_EINVOICE_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.CREATE_EINVOICE_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getEInvoiceCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_EINVOICE_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.GET_EINVOICE_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.data,
      };
    case type.GET_EINVOICE_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateEInvoiceCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_EINVOICE_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_EINVOICE_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.UPDATE_EINVOICE_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteEInvoiceCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_EINVOICE_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_EINVOICE_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.DELETE_EINVOICE_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
